<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="rec_fee_schdl"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >WORKCARDS and FINGERPRINTS
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <div class="bcs-expansion-content mt-4">
        <div class="mt-6 text-body2 text-sm-h6 text-md-h6">
          WORK APPLICANT REGISTRATION UNIT
          <div>
            The Work Applicant Registration Unit is responsible for the
            registration of convicted persons and the processing and
            fingerprinting of employees for the issuance of work cards as
            required by Reno Municipal Code and Nevada Revised Statute, i.e.
            taxi, limousine, and tow truck drivers, massage technicians, exotic
            dancers, and solicitors. This Unit is also charged with the
            responsibility of fingerprinting and issuing City employee
            identification cards.
          </div>
          <a href="/workcards" target="_self">
            WORK APPLICANT REGISTRATION UNIT</a
          >
        </div>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
.bcs-expansion-content {
  color: black;
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rec_fee_schdl",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
